import { fetchCurrentUser } from '../../ducks/user.duck';
import { adminUpdateUserApi, onElephantTrustSignupCheck, onFetchElephantUserFind, onSendElephantFeedBack, onUpdateElephantUser } from '../../util/api';
import { storableError } from "../../util/errors";
import { parse } from "../../util/urlHelpers";

// ================ Action types ================ //

export const FETCH_USER_REQUEST = 'app/AdminPanelUserPage/FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'app/AdminPanelUserPage/FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'app/AdminPanelUserPage/FETCH_USER_ERROR';

export const UPDATE_USER_REQUEST = 'app/AdminPanelUserPage/UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'app/AdminPanelUserPage/UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'app/AdminPanelUserPage/UPDATE_USER_ERROR';

export const SEND_FEEDBACK_REQUEST = 'app/AdminPanelUserPage/SEND_FEEDBACK_REQUEST';
export const SEND_FEEDBACK_SUCCESS = 'app/AdminPanelUserPage/SEND_FEEDBACK_SUCCESS';
export const SEND_FEEDBACK_ERROR = 'app/AdminPanelUserPage/SEND_FEEDBACK_ERROR';

export const ELEPHANT_TRUST_SIGNUP_CHECK_REQUEST = 'app/AdminPanelUserPage/ELEPHANT_TRUST_SIGNUP_CHECK_REQUEST';
export const ELEPHANT_TRUST_SIGNUP_CHECK_SUCCESS = 'app/AdminPanelUserPage/ELEPHANT_TRUST_SIGNUP_CHECK_SUCCESS';
export const ELEPHANT_TRUST_SIGNUP_CHECK_ERROR = 'app/AdminPanelUserPage/ELEPHANT_TRUST_SIGNUP_CHECK_ERROR';

const UESR_PER_PAGE = 10;

// ================ Reducer ================ //

const initialState = {
  pagination: null,
  fetchUserRequest: false,
  allUsers: null,
  fetchUserError: null,
  updateUserRequest: false,
  updateUserError: null,
  sendFeedbackInProgress: false,
  sendFeedbackError: null,
  elephantTrustSignupCheckInProgress: false,
  elephantTrustSignupCheckError: null
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case ELEPHANT_TRUST_SIGNUP_CHECK_REQUEST:
      return {
        ...state,
        elephantTrustSignupCheckInProgress: payload,
        elephantTrustSignupCheckError: null
      };
    case ELEPHANT_TRUST_SIGNUP_CHECK_SUCCESS:
      return {
        ...state,
        elephantTrustSignupCheckInProgress: false,
        elephantTrustSignupCheckError: null
      };
    case ELEPHANT_TRUST_SIGNUP_CHECK_ERROR:
      return {
        ...state,
        elephantTrustSignupCheckInProgress: false,
        elephantTrustSignupCheckError: payload
      };

    case FETCH_USER_REQUEST:
      return {
        ...state,
        pagination: null,
        fetchUserRequest: true,
        allUsers: null,
        fetchUserError: null
      };

    case FETCH_USER_SUCCESS:
      return {
        ...state,
        pagination: payload.meta,
        fetchUserRequest: false,
        allUsers: payload.data,
        fetchUserError: null
      };

    case FETCH_USER_ERROR:
      return {
        ...state,
        pagination: null,
        fetchUserRequest: false,
        allUsers: null,
        fetchUserError: true
      };


    case UPDATE_USER_REQUEST:
      return {
        ...state,
        updateUserRequest: payload,
        updateUserError: null,

      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUserRequest: false,
        updateUserError: null,
        allUsers: state.allUsers.map((st) => st.userId == payload.userId ? payload : st),
      };

    case UPDATE_USER_ERROR:
      return {
        ...state,
        updateUserRequest: false,
        updateUserError: true,
      };

    case SEND_FEEDBACK_REQUEST:
      return {
        ...state,
        sendFeedbackInProgress: true,
        sendFeedbackError: null,
      };

    case SEND_FEEDBACK_SUCCESS:
      return {
        ...state,
        sendFeedbackInProgress: false,
        sendFeedbackError: null,
      };

    case SEND_FEEDBACK_ERROR:
      return {
        ...state,
        sendFeedbackInProgress: false,
        sendFeedbackError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

// Action Creators
export const fetchUserRequest = () => ({ type: FETCH_USER_REQUEST });
export const fetchUserSuccess = response => ({
  type: FETCH_USER_SUCCESS,
  payload: response
});
export const fetchUserError = error => ({
  type: FETCH_USER_ERROR,
  payload: error
});


export const updateUserRequest = (platformPermission) => ({ type: UPDATE_USER_REQUEST, payload: platformPermission });
export const updateUserSuccess = user => ({ type: UPDATE_USER_SUCCESS, payload: user });
export const updateUserError = error => ({ type: UPDATE_USER_ERROR, payload: error });

export const sendFeedbackRequest = () => ({ type: SEND_FEEDBACK_REQUEST });
export const sendFeedbackSuccess = response => ({ type: SEND_FEEDBACK_SUCCESS, payload: response });
export const sendFeedbackError = error => ({ type: SEND_FEEDBACK_ERROR, payload: error });

export const elephantTrustSignupCheckRequest = (userId) => ({ type: ELEPHANT_TRUST_SIGNUP_CHECK_REQUEST, payload: userId });
export const elephantTrustSignupCheckSuccess = (result) => ({ type: ELEPHANT_TRUST_SIGNUP_CHECK_SUCCESS, payload: result });
export const elephantTrustSignupCheckError = (error) => ({ type: ELEPHANT_TRUST_SIGNUP_CHECK_ERROR, payload: error });

// ================ Thunks ================ //

export const elephantTrustSignupCheck = (userId, search) => async (dispatch, getState, sdk) => {
  dispatch(elephantTrustSignupCheckRequest(userId));
  try {
    const result = await onElephantTrustSignupCheck({
      userId: userId,
      clientFingerprint: {},
      type:"admin-reevaluation"
    });
    dispatch(elephantTrustSignupCheckSuccess());
    const {
      pageParams,
      payload,
      sortMap
    } = getFetchUserParmsFromSearch(search);

    dispatch(fetchUsers({
      pageParams,
      payload,
      sortMap
    }));

    return result;
  } catch (error) {
    const errorMessage = storableError(error);
    console.log(errorMessage, '&&& &&& => errorMessage');
    dispatch(elephantTrustSignupCheckError(errorMessage));
    throw error;
  }
};
export const fetchUsers = params => async (dispatch, getState, sdk) => {
  dispatch(fetchUserRequest());
  try {
    // onFetchElephantUserFind
    const response = await onFetchElephantUserFind(params);
    dispatch(fetchUserSuccess(response));
    return response;
  } catch (error) {
    const errorMessage = storableError(error)
    dispatch(fetchUserError(errorMessage));
    throw error;
  }
};


export const updateUser = (userId, payload, mongoPayload) => async (dispatch, getState, sdk) => {
  dispatch(updateUserRequest(payload?.privateData?.platformPermission || true));
  try {
    const updated = await adminUpdateUserApi({ userId, payload });
    const updateMongo = await onUpdateElephantUser(mongoPayload);
    dispatch(updateUserSuccess(updateMongo.data));
    return updated;
  } catch (error) {
    const errorMessage = storableError(error);
    dispatch(updateUserError(errorMessage));
    throw error;
  }
};

export const sendElephantFeedback = (feedbackPayload) => async dispatch => {
  dispatch(sendFeedbackRequest());
  try {
    const response = await onSendElephantFeedBack(feedbackPayload);
    dispatch(sendFeedbackSuccess(response));
    return response;
  } catch (error) {
    const errorMessage = storableError(error);
    dispatch(sendFeedbackError(errorMessage));
    throw error;
  }
};

const getFetchUserParmsFromSearch = (queryParams) => {
  const {
    page = 1,
    query,
    sortBy,
  } = queryParams;

  const pageParams = {
    page,
    perPage: UESR_PER_PAGE,
  };

  const payload = {};
  if (query) {
    Object.assign(payload, {
      email: { $regex: query },
    })
  };

  const sortMap = {};
  if (["sort_risk_score_asc", "sort_risk_score_desc"].includes(sortBy)) {
    sortMap.elephantScore = sortBy == "sort_risk_score_desc" ? -1 : 1
  };
  if (["sort_risk_status_asc", "sort_risk_status_desc"].includes(sortBy)) {
    sortMap.elephantStatus = sortBy == "sort_risk_status_desc" ? -1 : 1
  };
  if (["sort_signup_date_asc", "sort_signup_date_desc"].includes(sortBy)) {
    sortMap.signupData = sortBy == "sort_signup_date_desc" ? -1 : 1
  };
  return {
    pageParams,
    payload,
    sortMap
  }
}

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  dispatch(fetchUserRequest());
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  const queryParams = parse(search);
  const {
    pageParams,
    payload,
    sortMap
  } = getFetchUserParmsFromSearch(queryParams);

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions))
    .then(response => {
      const currentUser = getState().user.currentUser;
      const { isUserAdmin = false } = currentUser?.attributes?.profile?.privateData ?? {};
      if (currentUser && currentUser?.attributes && isUserAdmin) {
        dispatch(fetchUsers({
          pageParams,
          payload,
          sortMap
        }));
      }
      return response;
    });
};
